import posthog from 'posthog-js'

const apiKey = import.meta.env.PUBLIC_POSTHOG_KEY
const apiHost = import.meta.env.PUBLIC_POSTHOG_HOST

// Skip PostHog entirely in local dev — keeps dev activity out of analytics/replays.
if (apiKey && !import.meta.env.DEV) {
    posthog.init(apiKey, {
        api_host: apiHost || 'https://us.i.posthog.com',
        autocapture: true,
        capture_pageview: true,
        capture_pageleave: true,
        session_recording: {
            recordCrossOriginIframes: true,
        },
    })
}

export default posthog
